import { BaseConfig } from '../ServiceConfig';

export interface WMSConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.WmsServiceConfigData';
  url: string;
}

export const WMSConfigurationFields: (keyof WMSConfiguration)[] = ['url'];

export const BlankWMSConfiguration: WMSConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.WmsServiceConfigData',
} as WMSConfiguration;
